import { render, staticRenderFns } from "./jcb-construction.vue?vue&type=template&id=062b8d1f&"
import script from "./jcb-construction.vue?vue&type=script&lang=js&"
export * from "./jcb-construction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports